export default function Hobbies() {
    const data = [
        "Coding",
        "Parkour",
        "Freerunning",
        "Calisthenics"
    ];

    return <p>{data.join(", ")}</p>;
}